import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Lock from '@material-ui/icons/Lock';

import { handleClickAway } from 'services/handleClickAway';
import AclFormContainer from 'components/AclForm/AclFormContainer';
import PopoutItem from 'components/PopoutItem/PopoutItem';
import styles from '../InstanceButtonItem.styles';

const propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    actionButton: PropTypes.string.isRequired,
    popoutIconContainer: PropTypes.string.isRequired,
    popoutIconLabel: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  statusDisplay: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
  newInstanceAcls: PropTypes.instanceOf(Array).isRequired,
};

export function UnstyledAclInstanceButtonItem({
  open,
  classes,
  setUiState,
  disabled,
  anchorEl,
  statusDisplay,
  instanceService,
  instanceId,
  newInstanceAcls,
}) {
  function handleClick(e) {
    e.stopPropagation();

    setUiState({
      open: !open,
      anchorEl: e.currentTarget,
    });
  }

  const theButton = (
    <div className={classes.instanceButtonItemContainer}>
      <Button
        disabled={disabled}
        onClick={handleClick}
        classes={{ root: classes.zeroPadding, text: classes.zeroPadding }}
        className={classes.actionButton}
        id="aclformpopout-button"
      >
        <div className={classes.popoutIconContainer}>
          <Lock disabled={disabled} className={classes.popoutIcon} />
          <span className={classes.popoutIconLabel}>Firewall</span>
        </div>
      </Button>
      <PopoutItem
        anchorEl={anchorEl}
        handleClick={handleClick}
        handleClickAway={(e) => handleClickAway(e, anchorEl, () => setUiState({ open: false }))}
        placement="bottom-end"
        open={open}
        popperId="aclformpopout"
      >
        <AclFormContainer
          instanceService={instanceService}
          instanceId={instanceId}
          newInstanceAcls={newInstanceAcls}
          closePopout={() => setUiState({ open: false })}
        />
      </PopoutItem>
    </div>
  );

  return disabled && statusDisplay === 'Ready' ? (
    <Tooltip
      title="You do not have the required access for this resource. Contact your organization owner."
      classes={{ tooltip: classes.tooltip }}
    >
      <span>{theButton}</span>
    </Tooltip>
  ) : (
    theButton
  );
}

UnstyledAclInstanceButtonItem.propTypes = propTypes;

export const uiConfig = {
  name: 'aclformpopoutitem',
  state: () => ({
    open: false,
    anchorEl: {},
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledAclInstanceButtonItem));
